export class DocumentDtoModel {
  identification: string;
  caseId: string;
  formIdentifier: string;
  title: string;
  description: string;
  lastUpdated: Date;
  lastUpdatedById: string;
  fileMetaData: {
    fileId: string;
    name: string;
    description: string;
    mimeType: string;
    category: string;
    size: string;
    extension: string;
  };
  position: number;
  type?: string;

  constructor(data: any) {
    this.identification = data.identification;
    this.caseId = data.caseId;
    this.formIdentifier = data.formIdentifier;
    this.title = data.title;
    this.description = data.description;
    this.lastUpdated = new Date(data.lastUpdated);
    this.lastUpdatedById = data.lastUpdatedById;
    this.fileMetaData = data.fileMetaData;
    this.position = data.position;
    this.type = data.type;
  }

  setFileId(fileId: string): void {
    if (this.fileMetaData) {
      this.fileMetaData.fileId = fileId;
    } else {
      this.fileMetaData = {
        fileId: fileId,
        name: '',
        description: '',
        mimeType: '',
        category: '',
        size: '',
        extension: ''
      };
    }
  }

  getFileId(): string | null {
    return this.fileMetaData ? this.fileMetaData.fileId : null;
  }
}
